<template>
	<div class="main">
		<div class="leftSidebar">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/' }">{{$t('nav.home')}}</el-breadcrumb-item>
			  <el-breadcrumb-item>{{$t('nav.yan')}}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="title">{{$t('nav.yan')}}</div>
			<div class="left_nav">
				<div v-for="(val,key) in research" :key='key' >
					<div v-if="key==0">
						<div class="link" @click="dianji">
							<span></span>
							<div v-if="$i18n.locale == 'zh'">{{val.title}}</div>
							<div v-else-if="$i18n.locale == 'en'">{{val.y_title}}</div>
							<div v-else>{{val.e_title}}</div>
							<i class="el-icon-caret-bottom" v-if="show==false"></i>
							<i class="el-icon-caret-top" v-if="show==true"></i>
						</div>
						<div class="xian" v-for="(item,key) in val.son" :key='key' @click="$router.push({ path:'/service/cro?id='+item.id })">
							<span v-if="show==true&&$i18n.locale == 'zh'" :class="item.id==$route.query.id?'toups':'toup'">{{item.title}} </span> 
							<span v-if="show==true&&$i18n.locale == 'en'" :class="item.id==$route.query.id?'toups':'toup'">{{item.y_title}} </span> 
							<span v-if="show==true&&$i18n.locale == 'ru'" :class="item.id==$route.query.id?'toups':'toup'">{{item.e_title}} </span> 
						</div>
					</div>
					<div  v-if="key==1">
						<div class="link" @click="dianji1">
							<span></span>
							<div v-if="$i18n.locale == 'zh'">{{val.title}}</div>
							<div v-else-if="$i18n.locale == 'en'">{{val.y_title}}</div>
							<div v-else>{{val.e_title}}</div>
							<i class="el-icon-caret-bottom" v-if="show1==false"></i>
							<i class="el-icon-caret-top" v-if="show1==true"></i>
						</div>
						<div class="xian" v-for="(item,key) in val.son" :key='key' @click="$router.push({ path:'/service/cro?id='+item.id })">
							<span v-if="show1==true&&$i18n.locale == 'zh'" :class="item.id==$route.query.id?'toups':'toup'">{{item.title}} </span> 
							<span v-if="show1==true&&$i18n.locale == 'en'" :class="item.id==$route.query.id?'toups':'toup'">{{item.y_title}} </span> 
							<span v-if="show1==true&&$i18n.locale == 'ru'" :class="item.id==$route.query.id?'toups':'toup'">{{item.e_title}} </span> 
						</div>
					</div>
					<div  v-if="key==2">
						<div class="link" @click="dianji2">
							<span></span>
							<div v-if="$i18n.locale == 'zh'">{{val.title}}</div>
							<div v-else-if="$i18n.locale == 'en'">{{val.y_title}}</div>
							<div v-else>{{val.e_title}}</div>
							<i class="el-icon-caret-bottom" v-if="show2==false"></i>
							<i class="el-icon-caret-top" v-if="show2==true"></i>
						</div>
						<div class="xian" v-for="(item,key) in val.son" :key='key' @click="$router.push({ path:'/service/cro?id='+item.id })">
							<span v-if="show2==true&&$i18n.locale == 'zh'" :class="item.id==$route.query.id?'toups':'toup'">{{item.title}} </span> 
							<span v-if="show2==true&&$i18n.locale == 'en'" :class="item.id==$route.query.id?'toups':'toup'">{{item.y_title}} </span> 
							<span v-if="show2==true&&$i18n.locale == 'ru'" :class="item.id==$route.query.id?'toups':'toup'">{{item.e_title}} </span> 
						</div>
					</div>
				</div>
				<!-- <router-link :to="{name:'cdmo'}" :class="$route.name=='cdmo'?'link active':'link'"><span></span>CDMO/CMC</router-link>
				<router-link :to="{name:'pharmacy'}" :class="$route.name=='pharmacy'?'link active':'link'"><span></span>药学质量研究</router-link> -->
			</div>
		</div> 
		<div class="container1">
			<router-view :key="$route.fullPath"></router-view>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				research:[],
				show:false,
				show1:false,
				show2:false,

			}
		},
		mounted() {
			this.getResearch()
		},
		methods: {
			dianji(){
				if(this.show==false){
					this.show=true
				}else{
					this.show=false
				}
			},
			dianji1(){
				if(this.show1==false){
					this.show1=true
				}else{
					this.show1=false
				}
			},
			dianji2(){
				if(this.show2==false){
					this.show2=true
				}else{
					this.show2=false
				}
			},
			getResearch() {
				var that = this;
				this.$axios
					.post("/api/index/research", {
					})
					.then(function (ret) {
						if (ret.data.code == 0) {
							that.research = ret.data.data.research;
						} else {
							that.$fail(ret.data.msg);
						}
					}
				);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;

		.leftSidebar {
			width: 360px;
			min-height: 900px;
			// overflow: auto;
			.el-breadcrumb{
				width: 360px;
				height: 96px;
				display: flex;
				align-items: center;
			}
			.title{
				width: 360px;
				// height: 60px;
				height: 70px;
				padding: 12px;
				background: #E5EBF5;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 24px;
				font-weight: bold;
				color: #004098;
			}
			.left_nav{
				width: 360px ;
				.title{
					height: 44px;
					display: flex;
					align-items: center;
					border-left: 10px solid #666666;
					font-size: 18px;
					color: #010101;
					padding-left: 40px;
				}
				.link{
					width: 360px;
					// height: 60px;
					line-height: 60px;
					background: #E5EBF5;
					display: flex;
					align-items: center;
					// justify-content:space-between;
					padding-left: 15px;
					font-size: 16px;
					color: #004098;
					position: relative;
					cursor: pointer;
					span{
						width: 20px;
						height: 20px;
						display: block;
						border: 6px solid #004098;
						border-radius: 50%;
						margin-right: 10px;
					}
					div{
						width:80%;
					}
				}
				.active,.link:hover{
					background:#004098;
					color: #fff;
					span{
						border-color: #fff;
					}
				}
			}
		}
		.leftSidebar::-webkit-scrollbar {
			display: none;
		}
		.container1 {
			margin: 96px 0;
			width: 800px;
			background-color: #fff;
			// overflow: auto;
		}
		.container1::-webkit-scrollbar {
			display: none;
		}
	}
	.toup{
		width: 360px;
		// height: 60px;
		line-height: 30px;
		background: #E5EBF5;
		display: flex;
		align-items: center;
		padding: 10px 20px 10px 40px;
		font-size: 16px;
		color: #004098;
		position: relative;
		cursor: pointer;
	}
	.toups{
		width: 360px;
		line-height: 30px;
		background: #004098;
		display: flex;
		align-items: center;
		padding: 10px 20px 10px 40px;
		font-size: 16px;
		color: #fff;
		position: relative;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/service/service.vue